module.exports = __webpack_public_path__ + "img/icon_head.a1279c9d.svg";